import styled, { StyledComponent } from 'styled-components';
import dayjs from 'dayjs';

type Props = {
  contents: string;
  exceptionStartTime?: string | null;
  exceptionEndTime?: string | null;
};
const FixedMessageComponent = ({ contents, exceptionStartTime, exceptionEndTime }: Props) => {
  return (
    <>
      <Div>
        <FirstDiv>
          <FirstDivTitle>메시지 내용</FirstDivTitle>
          <FirstDivSubTitle>카카오 알림톡으로 발송되며, 카카오톡이 없는 수신인은 LMS로 수신합니다.</FirstDivSubTitle>
        </FirstDiv>
        <SecondDiv>
          <SecondDivContent>{contents.replaceAll('<br>', '\n') ?? ''}</SecondDivContent>
        </SecondDiv>
        {exceptionStartTime && exceptionEndTime && (
          <SetTimeDiv>
            <SetTimeFirstDiv>
              <SetTimeFirstDivToggleDesc>
                <ToggleBoxContainer>
                  <StyledCheckbox disabled={true} checked={false} onChange={() => {}} />
                </ToggleBoxContainer>
                <SetTimeFirstDivToggleTitle>발송예외 시간 설정</SetTimeFirstDivToggleTitle>
              </SetTimeFirstDivToggleDesc>
              <SetTimeFirstDivToggleSubTitle>
                설정한 시간에는 메시지 발송이 되지 않습니다. 발송 이력 조회에서 내역만 조회할 수 있습니다.
              </SetTimeFirstDivToggleSubTitle>
            </SetTimeFirstDiv>
            <SetTimeDivSecondDiv>
              <SetTimeDivSecondDiv>
                <TimeContaniner color={'#f9f9f9'}>
                  <TimeInput
                    type="number"
                    min={0}
                    max={23}
                    name="sendStartHour"
                    value={
                      dayjs(exceptionStartTime, 'HH:mm:ss').hour().toString().length === 1
                        ? `0${dayjs(exceptionStartTime, 'HH:mm:ss').hour()}`
                        : dayjs(exceptionStartTime, 'HH:mm:ss').hour().toString()
                    }
                    // onChange={onChangeTime}
                    disabled={true}
                  />
                  <TimeText>시</TimeText>
                </TimeContaniner>
                <TimeContaniner color={'#f9f9f9'}>
                  <TimeInput
                    type="number"
                    min={0}
                    max={59}
                    name="sendStartMinute"
                    value={
                      dayjs(exceptionStartTime, 'HH:mm:ss').minute().toString().length === 1
                        ? `0${dayjs(exceptionStartTime, 'HH:mm:ss').minute()}`
                        : dayjs(exceptionStartTime, 'HH:mm:ss').minute().toString()
                    }
                    // onChange={onChangeTime}
                    disabled={true}
                  />
                  <TimeText>분</TimeText>
                </TimeContaniner>
              </SetTimeDivSecondDiv>
              ~
              <SetTimeDivSecondDiv>
                <TimeContaniner color={'#f9f9f9'}>
                  <TimeInput
                    type="number"
                    min={0}
                    max={23}
                    name="sendEndHour"
                    value={
                      dayjs(exceptionEndTime, 'HH:mm:ss').hour().toString().length === 1
                        ? `0${dayjs(exceptionEndTime, 'HH:mm:ss').hour()}`
                        : dayjs(exceptionEndTime, 'HH:mm:ss').hour().toString()
                    }
                    // onChange={onChangeTime}
                    disabled={true}
                  />
                  <TimeText>시</TimeText>
                </TimeContaniner>
                <TimeContaniner color={'#f9f9f9'}>
                  <TimeInput
                    type="number"
                    min={0}
                    max={59}
                    name="sendEndMinute"
                    value={
                      dayjs(exceptionEndTime, 'HH:mm:ss').minute().toString().length === 1
                        ? `0${dayjs(exceptionEndTime, 'HH:mm:ss').minute()}`
                        : dayjs(exceptionEndTime, 'HH:mm:ss').minute().toString()
                    }
                    // onChange={onChangeTime}
                    disabled={true}
                  />
                  <TimeText>분</TimeText>
                </TimeContaniner>
              </SetTimeDivSecondDiv>
            </SetTimeDivSecondDiv>
          </SetTimeDiv>
        )}
      </Div>
    </>
  );
};

export default FixedMessageComponent;

const Div = styled.div`
  display: flex;
  padding: 0px 20px 20px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
`;
const FirstDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const FirstDivTitle = styled.div`
  color: var(--RG02, #25282f);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body16B */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;
const FirstDivSubTitle = styled.div`
  color: var(--GrayScale-gray800, #565b69);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body14M */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;
const SecondDiv = styled.div`
  //readonly로 처리할것
  display: flex;
  padding: 8px 10px;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid var(--RG06, #d8ddea);
  background: #f9f9f9;

  color: var(--semantic-color-text-text-default, #1c1d23);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body14M */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;
const SecondDivContent = styled.div`
  flex: 1 0 0;
  color: #6e727c;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;

  white-space: pre-wrap;
`;
const SetTimeDiv = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;
const SetTimeFirstDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
const SetTimeFirstDivToggleDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const SetTimeFirstDivToggleTitle = styled.div`
  color: var(--RG02, #25282f);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body16B */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;
const SetTimeFirstDivToggleSubTitle = styled.div`
  color: var(--GrayScale-gray800, #565b69);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body14M */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;

const ToggleBoxContainer = styled.div`
  width: 32px;
  height: 20px;
  flex-shrink: 0;
`;

const StyledCheckbox: StyledComponent<
  'input',
  any,
  {
    type: 'checkbox';
  },
  'type'
> = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  position: relative;
  border: max(2px, 0.1em) solid #e2e4eb;
  border-radius: 1.25em;
  width: 32px;
  height: 20px;
  background-color: #e2e4eb;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 17px;
    height: 17px;
    border-radius: 50%;
    transform: scale(0.8);
    background-color: #ffffff;
    transition: left 250ms linear;
  }

  &:checked {
    background-color: #1c48cd;
    border-color: #1c48cd;
  }

  &:checked::before {
    background-color: #ffffff;
    left: 11px;
  }
`;

const SetTimeDivSecondDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TimeContaniner = styled.div`
  display: flex;
  width: 68px;
  height: 40px;
  padding: 8px 10px 8px 10px;
  align-items: center;
  gap: 10px;

  border-radius: 8px;
  border: 1px solid var(--RG06, #d8ddea);
  background: var(--RG00, #fff);
  background-color: ${props => props.color};
`;

const TimeInput = styled.input`
  background-color: inherit;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  width: 25px;

  color: #6e727c;

  /* subheadline2 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.28px;

  /* padding: 8px 10px 8px 10px; */
`;

const TimeText = styled.div`
  color: #6e727c;
  width: 13px;
  z-index: 1;
  position: relative;

  /* subheadline2 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.28px;
`;
